/**
 * App 컴포넌트 (루트 컴포넌트)
 *
 * 앱의 최상위 컴포넌트입니다.
 * 라우팅과 레이아웃을 설정합니다.
 *
 * 간소화된 라우팅:
 * - / : 홈페이지 (허밍 검색 + 가사 검색 탭)
 *
 * 제거된 페이지:
 * - /humming : 홈페이지로 통합
 * - /search  : 홈페이지로 통합
 * - /stats   : 불필요 (포트폴리오에 필요 없음)
 */

import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { HomePage } from './pages/HomePage'

// =============================================================================
// 메인 컴포넌트
// =============================================================================

function App() {
  return (
    <Layout>
      <Routes>
        {/* 홈페이지 - 모든 검색 기능 포함 */}
        <Route path="/" element={<HomePage />} />

        {/* 다른 경로는 모두 홈으로 리다이렉트 */}
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Layout>
  )
}

export default App
